"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackUser = exports.trackLogin = void 0;
var dataLayer = [];
if (typeof window !== 'undefined') {
    dataLayer = window.dataLayer || [];
    window.dataLayer = dataLayer;
}
var push = function (data) {
    if (dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push) {
        dataLayer.push(data);
    }
};
var trackLogin = function (isManualLogin) {
    push({
        event: 'login1',
        loginType: 'm-login',
        autologin: !isManualLogin,
    });
};
exports.trackLogin = trackLogin;
var trackUser = function (mtid, hasCumulusConnected) {
    push({
        mtid: mtid,
        hasCumulusConnected: hasCumulusConnected,
        event: 'mtidExists',
    });
};
exports.trackUser = trackUser;
